module.exports = __webpack_public_path__ + "static/media/welcome.a2e28adc.gif";